module.exports = {"210711001":"太和街道","210711002":"兴隆街道","210711003":"汤河子街道","210711004":"凌西街道","210711007":"大薛街道","210711008":"女儿河街道","210711009":"营盘街道","210711010":"新民街道","210711070":"王家街道","210711071":"天桥街道","210711072":"杏山街道","210711073":"娘娘宫街道","210711080":"凌南街道","210711081":"松山街道","210711480":"锦州市果树农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210711.json
// module id = 505
// module chunks = 0